import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export type SessionStatus =
	"INITIALIZED" |
	"CANCELLED" |
	"LOGIN_WAITING" |
	"LOGIN_SUBMITTING" |
	"LOGIN_ERROR" |
	"LOGIN_SUCCESS" |
	"MFA_METHOD_WAITING" |
	"MFA_METHOD_SUBMITTING" |
	"MFA_METHOD_ERROR" |
	"MFA_METHOD_SUCCESS" |
	"MFA_CODE_WAITING_SMS" |
	"MFA_CODE_WAITING_EMAIL" |
	"MFA_CODE_SUBMITTING" |
	"MFA_CODE_ERROR_SMS" |
	"MFA_CODE_ERROR_EMAIL" |
	"MFA_CODE_ERROR_USER_LOCKED" |
	"MFA_CODE_ERROR_MAX_ATTEMPTS" |
	"MFA_CODE_SUCCESS" |
	"AUTHZ_WAITING" |
	"AUTHZ_SUBMITTING" |
	"AUTHZ_ERROR" |
	"AUTHZ_SUCCESS" |
	"ACCOUNT_LIST_SUBMITTING" |
	"ACCOUNT_LIST_SUCCESS" |
	"ACCOUNT_LIST_ERROR"
interface AppState {
	isLoading: boolean,
	session: {
		sessionId: string | null
		createdAt: Date | null
		expiresAt: Date | null
	},
	sessionStatus: SessionStatus,
	forceCheckSessionStatus: boolean,
	utilityResponse: any,
	maskedPhoneNumber: string | null,
	maskedEmailAddress: string | null,
}

interface AppStateAndStateSetters extends AppState {
	// Actions
	setSessionId: (sessionId: string) => void;
	setSessionStatus: (status: SessionStatus) => void;
	setForceCheckSessionStatus: (shouldCheck: boolean) => void;
	setUtilityResponse: (utilityResponse: any) => void;
	setMaskedPhoneNumber: (maskedPhoneNumber: string) => void;
	setMaskedEmailAddress: (maskedEmailAddress: string) => void;
    resetStore: () => void;
}

const initialState: AppState = {
	isLoading: false,
	session: {
		sessionId: null,
		createdAt: null,
		expiresAt: null
	},
	sessionStatus: "INITIALIZED" as SessionStatus,
	forceCheckSessionStatus: false,
	utilityResponse: null,
	maskedPhoneNumber: null,
	maskedEmailAddress: null
};

export const useAppStore = create<AppStateAndStateSetters>()(
	devtools(
		persist(
			(set) => ({
				...initialState,

				setSessionId: (sessionId: string) => set({
					session: {
						sessionId,
						createdAt: new Date(),
						expiresAt: new Date(new Date().getTime() + 1000 * 60 * 5)
					},
				}),

				setSessionStatus: (sessionStatus: SessionStatus) => set({
					sessionStatus
				}),

				setForceCheckSessionStatus: (shouldCheck: boolean) => set({
					forceCheckSessionStatus: shouldCheck
				}),

				setUtilityResponse: (utilityResponse: any) => set({
					utilityResponse
				}),

				setMaskedPhoneNumber: (maskedPhoneNumber: string) => set({
					maskedPhoneNumber
				}),

				setMaskedEmailAddress: (maskedEmailAddress: string) => set({
					maskedEmailAddress
                }),

                resetStore: () => set(initialState)
			}),
			{
				name: "appStore"
			}
		)
	)
);
